module.exports = __webpack_public_path__ + "img/Iconen Class Action website-02.4bb38e1c.svg";